import React from 'react';
import { DeleteNews } from '../DeleteNews';
import { useNavigate } from 'react-router-dom';

import { S } from './NewsItem.styles';

type Props = {
  faqId: string;
  faqQuestion: string;
};

export const NewsItem: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  const navigateToFaqEditor = (faqId: string) => {
    navigate(`${faqId}`);
  };
  return (
    <S.FaqListItem onClick={() => navigateToFaqEditor(props.faqId)}>
      {props.faqQuestion}
      <DeleteNews faqId={props.faqId} />
    </S.FaqListItem>
  );
};
